module.exports = __webpack_public_path__ + "img/激情.15089569.png";